import { OpenindDayDate } from "../App"
import { hitLocationColorMap } from "./ColorMap"
import { getHitDirectionTag, hittype_map } from "./DataProcess"
import { TaggedPitchTypeLabelMap } from "./FilterValueMap"
import { getDecimalData, getPercentageData } from "./utilFuncs"

export const strk_set = ['In-Play', 'Strk-C', 'Strk-S', 'Foul', 'Inplay']
export const swing_set = ['In-Play', 'Strk-S', 'Foul', 'Inplay']
export const contact_set = ['In-Play', 'Foul', 'Inplay']
export const non_ab_set = ['BB', 'BB-I', 'BB-IL', 'IBB', 'SH', 'SF', 'E-SF', 'FSH', 'E-SHC', 'E-SHT', 'HBP', 'OBC']
export const hit_set = ['1B', '2B', '3B', 'HR', 'IHR']
export const error_set = ['E-T', 'E-C', 'E-SF', 'E-SHC', 'E-SHT']
export const nibb_set = ['BB', 'BB-I', 'BB-IL']
export const k_set = ['K', 'Ks', 'K-SF', 'K-DO', 'K-BF', 'K-DS', 'K-BS']
export const invalid_set = [null, undefined, 0, '0', '']
const parseDirection = (directon) => {
  let spoint = directon.indexOf(':')
  if (spoint === -1) return undefined
  let hour = parseInt(directon.slice(0, spoint))
  let min = parseInt(directon.slice(spoint+1))
  if (isNaN(hour) || isNaN(min)) return undefined
  return [hour, min]
}
const computeAverageDirection = (h, m, c) => {
  if (c === 0 || (h === 0 && m === 0)) return '-'
  else {
    let ah, am, total = Math.round((h*60 + m)/c);
    ah = Math.floor(total/60)
    am = total%60
    if (ah > 12) ah -= 12
    if (am < 10) am = `0${am}`
    return `${ah}:${am}`
  }
}
const getYearMonthFromDateString = (date) => {
  let time = new Date(date)
  return { y: time.getFullYear(), m: time.getMonth()+1 }
}

export const resolvePitcherPersonalData = (data) => {
  const output = {
    chart: {},
    pts: {}, // pitchTypes stats
    stats: [],
    pbp: {},
    pbpf: {}
  }
  let pitchTypesData = {}, stats = {swing: 0, count: 0, whiff: 0, oswing: 0, zswing: 0, ocount: 0, zcount: 0, zcontact: 0}
  let barrel = {count: 0}
  // sg { type: { velo: count } }
  // sdg { type: int[24] }
  // mg { type: [{ x: hb, y: vb }] }
  // pr **pending**
  // zg, rg { type: [{ x, y }] }
  // trends { type: [{ x: index, y: value }] }
  let speedGraph = {}, sdirGraph = {}, mvtGraph = {}, zoneGraph = {}, whiffZoneGraph = {}, gbZoneGraph = {}, hZoneGraph = [], releaseGraph = {}, spinTrend = {}, hbTrend = {}, vbTrend = {}
  let playData = [], newPlay = true, playPitchCount = 0;

  for (const p of data) {
    stats.count++
    if (p.PitchCode === 'Strk-S') stats.whiff++
    if (p.Zone) {
      stats.zcount++
      if (swing_set.includes(p.PitchCode)) {
        stats.swing++
        stats.zswing++
      }
      if (contact_set.includes(p.PitchCode)) stats.zcontact++
    } else {
      stats.ocount++
      if (swing_set.includes(p.PitchCode)) {
        stats.swing++
        stats.oswing++
      }
    }

    if ((p.PitchCode === 'In-Play' || p.PitchCode === 'Inplay') && (p.BarrelType !== undefined && p.BarrelType !== 'None')) {
      if (barrel[p.BarrelType] === undefined) {
        barrel[p.BarrelType] = 0
      }
      barrel[p.BarrelType]++
      barrel.count++
    }
    if (["?", "UN", undefined, null].includes(p.TaggedPitchType) || p.TaggedPitchType[0] === undefined) continue
    if (pitchTypesData[p.TaggedPitchType] === undefined) {
      pitchTypesData[p.TaggedPitchType] = { vsum: 0, vcount: 0, vmax: 0, ssum: 0, scount: 0, smax: 0, sesum: 0, secount: 0, sdh: 0, sdm: 0, sdcount: 0, gsum: 0, gcount: 0, vb: 0, hb: 0, bcount: 0, strk: 0, swing: 0, whiff: 0, count: 0 }
    }
    let v = parseFloat(p.APP_VeloRel), s = parseFloat(p.SpinRate), sdir = parseDirection(p.SpinClock), se = parseFloat(p.SpinEFF), g = parseInt(p.Gyro), vb = parseFloat(p.InducedVertBeak), hb = parseFloat(p.HorzBreak)
    let zx = parseFloat(p.APP_KZoneY), zy = parseFloat(p.APP_KZoneZ), lx = parseFloat(p.LocX), ly = parseFloat(p.LocY), rs = parseFloat(p.ReleaseSide), rh = parseFloat(p.ReleaseHeight)
    if (!isNaN(v) && v > 0) {
      // table
      pitchTypesData[p.TaggedPitchType].vcount++
      pitchTypesData[p.TaggedPitchType].vsum += v
      if (v > pitchTypesData[p.TaggedPitchType].vmax) pitchTypesData[p.TaggedPitchType].vmax = v
      // chart
      if (speedGraph[p.TaggedPitchType] === undefined) {
        speedGraph[p.TaggedPitchType] = {velos: []}
      }
      // if (speedGraph[p.TaggedPitchType].velos[Math.round(v)] === undefined) speedGraph[p.TaggedPitchType].velos[Math.round(v)] = 1
      // else speedGraph[p.TaggedPitchType].velos[Math.round(v)]++
      speedGraph[p.TaggedPitchType].velos.push(v)
    }

    if (!isNaN(s) && s > 0) {
      // table
      pitchTypesData[p.TaggedPitchType].scount++
      pitchTypesData[p.TaggedPitchType].ssum += s
      pitchTypesData[p.TaggedPitchType].smax = Math.max(pitchTypesData[p.TaggedPitchType].smax, s)
      if (se > 0) {
        pitchTypesData[p.TaggedPitchType].sesum += se
        pitchTypesData[p.TaggedPitchType].secount++
      }
      if (sdir !== undefined) {
        pitchTypesData[p.TaggedPitchType].sdh += sdir[0]
        pitchTypesData[p.TaggedPitchType].sdm += sdir[1]
        pitchTypesData[p.TaggedPitchType].sdcount++
      }
      if (g > 0) {
        pitchTypesData[p.TaggedPitchType].gsum += g
        pitchTypesData[p.TaggedPitchType].gcount++
      }
      // chart
      if (sdirGraph[p.TaggedPitchType] === undefined) {
        sdirGraph[p.TaggedPitchType] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }
      if (sdir !== undefined) {
        let idx = sdir[0]*2 + (sdir[1]>=30? 1:0)
        sdirGraph[p.TaggedPitchType][idx]++
      }
      if (spinTrend[p.TaggedPitchType] === undefined) {
        spinTrend[p.TaggedPitchType] = []
      }
      spinTrend[p.TaggedPitchType].push({x: spinTrend[p.TaggedPitchType].length, y: s})
    }
    if ((!isNaN(vb) && !isNaN(hb)) && (vb !== 0 || hb !== 0)) {
      // table
      pitchTypesData[p.TaggedPitchType].bcount++
      pitchTypesData[p.TaggedPitchType].vb += vb
      pitchTypesData[p.TaggedPitchType].hb += hb
      // chart
      if (mvtGraph[p.TaggedPitchType] === undefined) {
        mvtGraph[p.TaggedPitchType] = []
        vbTrend[p.TaggedPitchType] = []
        hbTrend[p.TaggedPitchType] = []
      }
      mvtGraph[p.TaggedPitchType].push({x: hb, y: vb})
      vbTrend[p.TaggedPitchType].push({x: vbTrend[p.TaggedPitchType].length, y: vb})
      hbTrend[p.TaggedPitchType].push({x: hbTrend[p.TaggedPitchType].length, y: hb})
    }
    if ((!isNaN(rs) && !isNaN(rh)) && (rs !== 0 || rh !== 0)) {
      if (releaseGraph[p.TaggedPitchType] === undefined) {
        releaseGraph[p.TaggedPitchType] = []
      }
      releaseGraph[p.TaggedPitchType].push({x: rs, y: rh})
    }
    if ((!isNaN(zx) && !isNaN(zy)) && (zx !== 0 || zy !== 0)) {
      if (zoneGraph[p.TaggedPitchType] === undefined) {
        zoneGraph[p.TaggedPitchType] = []
        gbZoneGraph[p.TaggedPitchType] = []
        whiffZoneGraph[p.TaggedPitchType] = []
        hZoneGraph[p.TaggedPitchType] = []
      }
      zoneGraph[p.TaggedPitchType].push({x: zx, y: zy})
      if (p.HitType === 'GROUND') gbZoneGraph[p.TaggedPitchType].push({x: zx, y: zy})
      if (p.PitchCode === 'Strk-S') whiffZoneGraph[p.TaggedPitchType].push({x: zx, y: zy})
      if (hit_set.includes(p.PA_Result)) hZoneGraph[p.TaggedPitchType].push({x: zx, y: zy})
    }
    if (strk_set.includes(p.PitchCode)) pitchTypesData[p.TaggedPitchType].strk++
    if (p.PitchCode === 'Strk-S') pitchTypesData[p.TaggedPitchType].whiff++
    if (swing_set.includes(p.PitchCode)) pitchTypesData[p.TaggedPitchType].swing++
    pitchTypesData[p.TaggedPitchType].count++

    // play by play
    let ym = getYearMonthFromDateString(p.Date)
    if (newPlay) {
      let initPlay = {
        pitcher: p.Pitcher, pitcherSide: p.PT===0? 'R':'L', batter: p.Batter, batterSide: p.BatS===0? 'R':'L', outs: p.Outs,
        date: p.Date, fieldGraphData: [], zoneGraphData: {}, pbp: [], playResult: {result: '-', ev: '-', la: '-'},
        gameNo: p.GameNo, inn: p.Inning, year: ym.y, month: ym.m, pteam: p.PitcherTeam, bteam: p.BatterTeam
      }
      playData.push(initPlay)
      newPlay = false
      playPitchCount = 1;
    }
    let pitch = { tag: p.TaggedPitchType, speed: '-', call: p.PitchCode, vtime: p.VideoTimePart, plate_id: p.plate_id, year: ym.y }
    if (!isNaN(v) && v > 0) pitch.speed = getDecimalData(v, 1, 1)
    playData.at(-1).pbp.push(pitch)
    if (playData.at(-1).zoneGraphData[p.TaggedPitchType] === undefined) playData.at(-1).zoneGraphData[p.TaggedPitchType] = []
    if ((!isNaN(zx) && !isNaN(zy)) && (zx !== 0 || zy !== 0)) playData.at(-1).zoneGraphData[p.TaggedPitchType].push({x: zx, y: zy, v: getDecimalData(v, 1, 1), n: playPitchCount})
    playPitchCount++;
    if (p.PA_Result !== undefined && p.PA_Result[0] !== undefined) { //play result meets
      newPlay = true
      let ev = parseFloat(p.ExitVelo), la = parseFloat(p.ExitAngle)
      if (!isNaN(ev) && ev > 0) playData.at(-1).playResult.ev = getDecimalData(ev, 1, 1)
      if (!isNaN(ev) && ev > 0 && !isNaN(la)) playData.at(-1).playResult.la = getDecimalData(la, 1, 1)
      playData.at(-1).playResult.result = p.PA_Result
      if ((!isNaN(lx) && !isNaN(ly)) && (lx !== 0 || ly !== 0)) {
        playData.at(-1).fieldGraphData[['1B', '2B', '3B', 'HR', 'IHR'].includes(p.PA_Result)? 'HIT':'OUT'] = [{x: lx, y: ly}]
      }
    }

  }
  // wrap up data
  output.stats.push(getPercentageData(stats.swing, stats.count, 1)) // swing%
  output.stats.push(getPercentageData(stats.zswing, stats.zcount, 1)) // z-swing%
  output.stats.push(getPercentageData(stats.oswing, stats.ocount, 1)) // o-swing%
  output.stats.push(getPercentageData(stats.zcontact, stats.zswing)) // z-contact%
  output.stats.push(getPercentageData(stats.whiff, stats.swing)) // whiff%
  output.stats.push(getPercentageData((barrel['Poorly-Weak'] || 0)+(barrel['Weak-Contact'] || 0), barrel.count))
  output.stats.push(getPercentageData(barrel['Poorly-Topped'], barrel.count))
  output.stats.push(getPercentageData(barrel['Poorly-Under'], barrel.count))
  output.stats.push(getPercentageData(barrel['Flare-or-Burner'], barrel.count))
  output.stats.push(getPercentageData(barrel['Solid-Contact'], barrel.count))
  output.stats.push(getPercentageData(barrel['Barrel'], barrel.count))
  
  for (let pt in pitchTypesData) {
    output.pts[pt] = []
    output.pts[pt].push(getDecimalData(pitchTypesData[pt].vsum, pitchTypesData[pt].vcount, 1))
    output.pts[pt].push(getDecimalData(pitchTypesData[pt].vmax, 1, 1))
    output.pts[pt].push(getPercentageData(pitchTypesData[pt].count, stats.count))
    output.pts[pt].push(getDecimalData(pitchTypesData[pt].ssum, pitchTypesData[pt].scount, 0))
    output.pts[pt].push(Math.round(pitchTypesData[pt].smax)? Math.round(pitchTypesData[pt].smax):'-')
    output.pts[pt].push(getDecimalData(pitchTypesData[pt].vb, pitchTypesData[pt].bcount, 1))
    output.pts[pt].push(getDecimalData(pitchTypesData[pt].hb, pitchTypesData[pt].bcount, 1))
    output.pts[pt].push(getDecimalData(pitchTypesData[pt].sesum, pitchTypesData[pt].secount, 1))
    output.pts[pt].push(getDecimalData(pitchTypesData[pt].gsum, pitchTypesData[pt].gcount, 1))
    output.pts[pt].push(computeAverageDirection(pitchTypesData[pt].sdh, pitchTypesData[pt].sdm, pitchTypesData[pt].sdcount))
    output.pts[pt].push(getPercentageData(pitchTypesData[pt].strk, pitchTypesData[pt].count))
    output.pts[pt].push(getPercentageData(pitchTypesData[pt].whiff, pitchTypesData[pt].swing))
  }

  for (let pt in speedGraph) {
    // for (let v in speedGraph[pt].velos) {
    //   speedGraph[pt].velos[v] = getDecimalData(speedGraph[pt].velos[v]*100, stats.count, 1)
    // }
    if (speedGraph[pt].velos.length < 10) {
      speedGraph[pt] = undefined
      continue
    }
    speedGraph[pt].avg = output.pts[pt][0]
    speedGraph[pt].usage = getDecimalData(pitchTypesData[pt].count*100, stats.count, 0)
  }

  output.chart = { speedGraph, sdirGraph, mvtGraph, zoneGraph, releaseGraph, spinTrend, hbTrend, vbTrend, gbZoneGraph, hZoneGraph, whiffZoneGraph }
  
  for (let pd of playData) {
    if (output.pbp[pd.year] === undefined) {
      output.pbp[pd.year] = {}
    }
    if (output.pbp[pd.year][pd.gameNo] === undefined) {
      output.pbp[pd.year][pd.gameNo] = {}
    }
    if (output.pbp[pd.year][pd.gameNo][pd.inn] === undefined) {
      output.pbp[pd.year][pd.gameNo][pd.inn] = []
    }
    if (output.pbpf[pd.year] === undefined) {
      output.pbpf[pd.year] = {}
    }
    if (output.pbpf[pd.year][pd.bteam] === undefined) {
      output.pbpf[pd.year][pd.bteam] = []
    }
    output.pbp[pd.year][pd.gameNo][pd.inn].push(pd)
    output.pbpf[pd.year][pd.bteam].push(pd)
  }

  // console.log(output.pbp)

  return output
}

const getBarrelGraphData = (ev, la) => {
  let sin = Math.sin(Math.PI*la/180), cos = Math.cos(Math.PI*la/180)
  return { x: ev*0.62137*cos, y: ev*0.62137*sin }
}

export const resolveBatterPersonalData = (data) => {
  const output = {
    chart: {},
    stats: [],
    pbp: {},
    pbpf: {}
  }
  let stats = {swing: 0, count: 0, whiff: 0, oswing: 0, zswing: 0, ocount: 0, zcount: 0, zcontact: 0, ev: 0, ev_count: 0, la: 0, la_count: 0, max_ev: 0}
  let evZoneGraph = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], laZoneGraph = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let counts = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let avgLZoneGraph = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], avgRZoneGraph = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let abLCount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], abRCount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let barrel = {count: 0}
  let barrelGraph = {}, evlaGraph = {ev: [], la: []}
  let playData = [], newPlay = true, playPitchCount = 0;
  for (const p of data) {
    stats.count++
    if (p.PitchCode === 'Strk-S') stats.whiff++
    if (p.Zone) {
      stats.zcount++
      if (swing_set.includes(p.PitchCode)) {
        stats.swing++
        stats.zswing++
      }
      if (contact_set.includes(p.PitchCode)) stats.zcontact++
    } else {
      stats.ocount++
      if (swing_set.includes(p.PitchCode)) {
        stats.swing++
        stats.oswing++
      }
    }

    let ym = getYearMonthFromDateString(p.Date)
    if (newPlay) {
      let initPlay = {
        pitcher: p.Pitcher, pitcherSide: p.PT===0? 'R':'L', batter: p.Batter, batterSide: p.BatS===0? 'R':'L', outs: p.Outs,
        date: p.Date, fieldGraphData: [], zoneGraphData: {}, pbp: [], playResult: {result: '-', ev: '-', la: '-'},
        gameNo: p.GameNo, inn: p.Inning, year: ym.y, month: ym.m, bteam: p.BatterTeam, pteam: p.PitcherTeam
      }
      playData.push(initPlay)
      newPlay = false
      playPitchCount = 1
    }
    
    let v = parseFloat(p.APP_VeloRel), zx = parseFloat(p.APP_KZoneY), zy = parseFloat(p.APP_KZoneZ), lx = parseFloat(p.LocX), ly = parseFloat(p.LocY)
    let pitch = { tag: p.TaggedPitchType, speed: '-', call: p.PitchCode, vtime: p.VideoTimePart, plate_id: p.plate_id, year: ym.y }
    if (!isNaN(v) && v > 0) pitch.speed = getDecimalData(v, 1, 1)
    playData.at(-1).pbp.push(pitch)
    if (playData.at(-1).zoneGraphData[p.TaggedPitchType] === undefined) playData.at(-1).zoneGraphData[p.TaggedPitchType] = []
    if ((!isNaN(zx) && !isNaN(zy)) && (zx !== 0 || zy !== 0)) playData.at(-1).zoneGraphData[p.TaggedPitchType].push({x: zx, y: zy, v: getDecimalData(v, 1, 1), n: playPitchCount})
    playPitchCount++
    if (p.PA_Result !== undefined && p.PA_Result[0] !== undefined) { //play result meets
      newPlay = true
      let ev = parseFloat(p.ExitVelo), la = parseFloat(p.ExitAngle)
      if (!isNaN(ev) && ev > 0) {
        playData.at(-1).playResult.ev = getDecimalData(ev, 1, 1)
        stats.ev += ev
        stats.ev_count++
        stats.max_ev = Math.max(stats.max_ev, ev)
      }
      if (!isNaN(ev) && ev > 0 && !isNaN(la)) {
        playData.at(-1).playResult.la = getDecimalData(la, 1, 1)
        stats.la += la
        stats.la_count++
      }
      playData.at(-1).playResult.result = p.PA_Result
      if ((!isNaN(lx) && !isNaN(ly)) && (lx !== 0 || ly !== 0)) {
        playData.at(-1).fieldGraphData[['1B', '2B', '3B', 'HR', 'IHR'].includes(p.PA_Result)? 'HIT':'OUT'] = [{x: lx, y: ly}]
      }
      // Avg Zone
      let zoneIdx = parseInt(p.OZone) > 10? parseInt(p.OZone)-2:parseInt(p.OZone)-1
      if (!non_ab_set.includes(p.PA_Result)) {
        if (parseInt(p.PT) === 0) abRCount[zoneIdx]++
        else abLCount[zoneIdx]++
      }
      if (hit_set.includes(p.PA_Result)) {
        if (parseInt(p.PT) === 0) avgRZoneGraph[zoneIdx]++
        else avgLZoneGraph[zoneIdx]++
      }
    }

    if (p.PitchCode === 'In-Play' || p.PitchCode === 'Inplay') {
      let ev = parseFloat(p.ExitVelo), la = parseFloat(p.ExitAngle)
      // if (!isNaN(v) && v > 0) {}
      if (!isNaN(ev) && ev > 0) {
        let zoneIdx = parseInt(p.OZone) > 10? parseInt(p.OZone)-2:parseInt(p.OZone)-1
        evZoneGraph[zoneIdx] += ev
        laZoneGraph[zoneIdx] += la
        counts[zoneIdx]++
        evlaGraph.ev.push({x: evlaGraph.ev.length, y: ev})
        evlaGraph.la.push({x: evlaGraph.la.length, y: la})
      }
      if (![undefined, 'None', "", " ", null].includes(p.BarrelType)) {
        if (barrel[p.BarrelType] === undefined) {
          barrel[p.BarrelType] = 0
          barrelGraph[p.BarrelType] = []
        }
        barrel[p.BarrelType]++
        barrel.count++
        barrelGraph[p.BarrelType].push(getBarrelGraphData(ev, la))
      }
    }

    
  }
  // wrap up data
  output.stats.push(getPercentageData(stats.swing, stats.count, 1)) // swing%
  output.stats.push(getPercentageData(stats.zswing, stats.zcount, 1)) // z-swing%
  output.stats.push(getPercentageData(stats.oswing, stats.ocount, 1)) // o-swing%
  output.stats.push(getPercentageData(stats.zcontact, stats.zswing)) // z-contact%
  output.stats.push(getPercentageData(stats.whiff, stats.swing)) // whiff%
  output.stats.push(getDecimalData(stats.ev, stats.ev_count, 1, '-')) // ev
  output.stats.push(stats.max_ev>0?stats.max_ev:'-') // max_ev
  output.stats.push(getDecimalData(stats.la, stats.la_count, 0, '-').slice(0,-1)+'°')
  output.stats.push(getPercentageData((barrel['Poorly-Weak'] || 0)+(barrel['Weak-Contact'] || 0), barrel.count))
  output.stats.push(getPercentageData(barrel['Poorly-Topped'], barrel.count))
  output.stats.push(getPercentageData(barrel['Poorly-Under'], barrel.count))
  output.stats.push(getPercentageData(barrel['Flare-or-Burner'], barrel.count))
  output.stats.push(getPercentageData(barrel['Solid-Contact'], barrel.count))
  output.stats.push(getPercentageData(barrel['Barrel'], barrel.count))
  
  for (let i=0; i<13; i++) {
    evZoneGraph[i] = getDecimalData(evZoneGraph[i], counts[i], 1, 0)
    laZoneGraph[i] = getDecimalData(laZoneGraph[i], counts[i], 1, 0)
    avgLZoneGraph[i] = getDecimalData(avgLZoneGraph[i], abLCount[i], 3, '0.000')
    avgRZoneGraph[i] = getDecimalData(avgRZoneGraph[i], abRCount[i], 3, '0.000')
  }

  output.chart = { evZoneGraph, laZoneGraph, evlaGraph, barrelGraph, avgLZoneGraph, avgRZoneGraph }

  for (let pd of playData) {
    if (output.pbp[pd.year] === undefined) {
      output.pbp[pd.year] = {}
    }
    if (output.pbp[pd.year][pd.gameNo] === undefined) {
      output.pbp[pd.year][pd.gameNo] = {}
    }
    if (output.pbp[pd.year][pd.gameNo][pd.inn] === undefined) {
      output.pbp[pd.year][pd.gameNo][pd.inn] = []
    }
    if (output.pbpf[pd.year] === undefined) {
      output.pbpf[pd.year] = {}
    }
    if (output.pbpf[pd.year][pd.pteam] === undefined) {
      output.pbpf[pd.year][pd.pteam] = []
    }
    output.pbp[pd.year][pd.gameNo][pd.inn].push(pd)
    output.pbpf[pd.year][pd.pteam].push(pd)
  }

  // console.log(output.pbp)

  return output
}

const getInningSum = (a, b) => {
  let as = a.toString(), bs = b.toString()
  let das = as.indexOf('.'), dbs = bs.indexOf('.')
  let az = das>0? parseInt(as.slice(0, das)):a, bz = dbs>0? parseInt(bs.slice(0, dbs)):b
  let ad = das>0? parseInt(as.slice(das+1, das+3)):0, bd = dbs>0? parseInt(as.slice(das+1, das+3)):0
  if (ad+bd >= 3) az++
  return `${az+bz}.${(ad+bd)%3}`
}
const getERA = (inn, er) => {
  let inns = inn.toString(), outs
  let dis = inns.indexOf('.')
  if (dis < 0) outs = parseInt(inn)*3
  else {
    outs = parseInt(inns.slice(0, dis))*3 + parseInt(inns.slice(dis+1, dis+3))
  }
  return getDecimalData(er*27, outs, 2)
}
const getCumulatedStatData = (data, type, id) => {
  if (data.length === 0) return []
  if (data.length === 1) return data[0].data.slice(1, )
  if (type === 'standard') {
    let initSum = [...data[0].data.slice(1, )]
    for (let i=1; i<data.length; i++) {
      for (let e=1; e<initSum.length; e++) {
        if (id === 'p' && e === 10) {
          initSum[e] = getInningSum(initSum[e], data[i].data[e])
        } else {
          initSum[e] = initSum[e] + data[i].data[e]
        }
      }
    }
    if (id === 'b') {
      initSum[initSum.length-1] = getDecimalData(initSum[3], initSum[1], 3)
      return initSum
    } else {
      initSum[2] = getERA(initSum[10], initSum[14])
      return initSum
    }
  }
}

const calculateOverallStats = (data, type) => {
  if (data.length === 0) return { advanced: [], standard: [], discipline: [], batted_ball: []}
  data.sort((a, b) => (a.Year - b.Year))
  // standard
  let standard = [], advanced = []
  if (type === 'batter') {
    let total = { G: 0, AB: 0, PA: 0, H: 0, '1B': 0, '2B': 0, '3B': 0, 'HR': 0, 'BB': 0, 'K': 0, SF: 0, SH: 0, SB: 0, InPlays: 0 }
    // columns -> year, gtype, g, ab, pa, h, 1b, 2b, 3b, hr, bb, so, sf, sh, sb, avg
    let yearly_cumulated = { G: 0, AB: 0, PA: 0, H: 0, '1B': 0, '2B': 0, '3B': 0, 'HR': 0, 'BB': 0, 'K': 0, SF: 0, SH: 0, SB: 0, InPlays: 0 }, current_year = data[0].Year
    for (const row of data) {
      if (row.Year !== current_year) {
        standard.push({title: current_year, data: ['年度成績', yearly_cumulated.G, yearly_cumulated.AB, yearly_cumulated.PA, yearly_cumulated.H, yearly_cumulated['1B'], yearly_cumulated['2B'], yearly_cumulated['3B'], yearly_cumulated.HR, yearly_cumulated.BB, yearly_cumulated.K, yearly_cumulated.SF, yearly_cumulated.SH, yearly_cumulated.SB, getDecimalData(yearly_cumulated.H, yearly_cumulated.AB, 3, '-')]})
        advanced.push({title: current_year, data: ['年度成績', getDecimalData(yearly_cumulated.H, yearly_cumulated.AB, 3), getDecimalData(yearly_cumulated.H+yearly_cumulated.BB, yearly_cumulated.PA, 3), getDecimalData(yearly_cumulated.H+yearly_cumulated["2B"]+yearly_cumulated["3B"]*2+yearly_cumulated.HR*3, yearly_cumulated.AB, 3), getDecimalData(yearly_cumulated["2B"]+yearly_cumulated["3B"]*2+yearly_cumulated.HR*3, yearly_cumulated.AB, 3), getDecimalData(yearly_cumulated.H-yearly_cumulated.HR, yearly_cumulated.InPlays-yearly_cumulated.HR, 3)]})
        yearly_cumulated = { G: 0, AB: 0, PA: 0, H: 0, '1B': 0, '2B': 0, '3B': 0, 'HR': 0, 'BB': 0, 'K': 0, SF: 0, SH: 0, SB: 0, InPlays: 0 }
        current_year = row.Year
      }
      standard.push({title: row.Year, data: [row.GameType, row.G, row.AB, row.PA, row.H, row['1B'], row['2B'], row['3B'], row.HR, row.BB, row.K, row.SF, row.SH, row.SB, row.AVG]})
      advanced.push({title: row.Year, data: [row.GameType, getDecimalData(row.AVG, 1, 3), getDecimalData(row.OBP, 1, 3), getDecimalData(row.SLG, 1, 3), getDecimalData(row.ISO, 1, 3), getDecimalData(row.BABIP, 1, 3)]})
      for (const key in total) {
        total[key] += row[key]
        yearly_cumulated[key] += row[key]
      }
    }
    standard.push({title: current_year, data: ['年度成績', yearly_cumulated.G, yearly_cumulated.AB, yearly_cumulated.PA, yearly_cumulated.H, yearly_cumulated['1B'], yearly_cumulated['2B'], yearly_cumulated['3B'], yearly_cumulated.HR, yearly_cumulated.BB, yearly_cumulated.K, yearly_cumulated.SF, yearly_cumulated.SH, yearly_cumulated.SB, getDecimalData(yearly_cumulated.H, yearly_cumulated.AB, 3, '-')]})
    advanced.push({title: current_year, data: ['年度成績', getDecimalData(yearly_cumulated.H, yearly_cumulated.AB, 3), getDecimalData(yearly_cumulated.H+yearly_cumulated.BB, yearly_cumulated.PA, 3), getDecimalData(yearly_cumulated.H+yearly_cumulated["2B"]+yearly_cumulated["3B"]*2+yearly_cumulated.HR*3, yearly_cumulated.AB, 3), getDecimalData(yearly_cumulated["2B"]+yearly_cumulated["3B"]*2+yearly_cumulated.HR*3, yearly_cumulated.AB, 3), getDecimalData(yearly_cumulated.H - yearly_cumulated.HR, yearly_cumulated.InPlays - yearly_cumulated.HR, 3)]})
    standard.push({title: 'Total', data: ['高中累計成績', total.G, total.AB, total.PA, total.H, total['1B'], total['2B'], total['3B'], total.HR, total.BB, total.K, total.SF, total.SH, total.SB, getDecimalData(total.H, total.AB, 3, '-')]})
    advanced.push({title: 'Total', data: ['高中累計成績', getDecimalData(total.H, total.AB, 3), getDecimalData(total.H+total.BB, total.PA, 3), getDecimalData(total.H+total["2B"]+total["3B"]*2+total.HR*3, total.AB, 3), getDecimalData(total["2B"]+total["3B"]*2+total.HR*3, total.AB, 3), getDecimalData(total.H-total.HR, total.InPlays-total.HR, 3)]})
  } else {
    let total = { G: 0, GS: 0, ER: 0, Outs: 0, PA: 0, H: 0, AB: 0, HR: 0, 'BB': 0, 'K': 0, InPlays: 0, OnBase: 0 }
    // columns -> year, gtype, g, gs, era, ip, tbf, h, er, hr, bb, so
    // advanced
    // columns -> year, gtype, k9, bb9, k/bb, k%, bb%, k-bb%, avg, whip, babip
    let yearly_cumulated = { G: 0, GS: 0, ER: 0, Outs: 0, PA: 0, H: 0, AB: 0, HR: 0, 'BB': 0, 'K': 0, InPlays: 0, OnBase: 0 }, current_year = data[0].Year
    for (const row of data) {
      if (row.Year !== current_year) {
        standard.push({title: current_year, data: ['年度成績', yearly_cumulated.G, yearly_cumulated.GS, getDecimalData(yearly_cumulated.ER * 27, yearly_cumulated.Outs, 2, '-'), `${yearly_cumulated.Outs/3}.${yearly_cumulated.Outs%3}`, yearly_cumulated.PA, yearly_cumulated.H, yearly_cumulated.ER, yearly_cumulated.HR, yearly_cumulated.BB, yearly_cumulated.K, getDecimalData(yearly_cumulated.H, yearly_cumulated.AB, 3, '-')]})
        advanced.push({title: current_year, data: ['年度成績', getDecimalData(yearly_cumulated.K * 27, yearly_cumulated.Outs, 1, '-'), getDecimalData(yearly_cumulated.BB * 27, yearly_cumulated.Outs, 1, '-'), getDecimalData(yearly_cumulated.K, yearly_cumulated.BB, 2, '-'), getPercentageData(yearly_cumulated.K, yearly_cumulated.PA, 2, '-'), getPercentageData(yearly_cumulated.BB, yearly_cumulated.PA, 2, '-'), getPercentageData(yearly_cumulated.K-yearly_cumulated.BB, yearly_cumulated.PA, 2, '-'), getDecimalData(yearly_cumulated.H, yearly_cumulated.AB, 2, '-'), getDecimalData(yearly_cumulated.OnBase*3, yearly_cumulated.Outs, 2, '-'), getDecimalData(yearly_cumulated.H, yearly_cumulated.InPlays, 2, '-')]})
        yearly_cumulated = { G: 0, GS: 0, ER: 0, Outs: 0, PA: 0, H: 0, AB: 0, HR: 0, 'BB': 0, 'K': 0, InPlays: 0, OnBase: 0 }
        current_year = row.Year
      }
      standard.push({title: row.Year, data: [row.GameType, row.G, row.GS, getDecimalData(row.ER * 27, row.Outs, 2, '-'), `${row.Outs/3}.${row.Outs%3}`, row.PA, row.H, row.ER, row.HR, row.BB, row.K, getDecimalData(row.AVG, 1, 3)]})
      advanced.push({title: row.Year, data: [row.GameType, getDecimalData(row.K * 27, row.Outs, 1, '-'), getDecimalData(row.BB * 27, row.Outs, 1, '-'), getDecimalData(row.K, row.BB, 2, '-'), getPercentageData(row.K, row.PA, 2, '-'), getPercentageData(row.BB, row.PA, 2, '-'), getPercentageData(row.K-row.BB, row.PA, 2, '-'), getDecimalData(row.H, row.AB, 3, '-'), getDecimalData(row.OnBase*3, row.Outs, 2, '-'), getDecimalData(row.H, row.InPlays, 2, '-')]})
      for (const key in total) {
        total[key] += row[key]
        yearly_cumulated[key] += row[key]
      }
    }
    standard.push({title: current_year, data: ['年度成績', yearly_cumulated.G, yearly_cumulated.GS, getDecimalData(yearly_cumulated.ER * 27, yearly_cumulated.Outs, 2, '-'), `${yearly_cumulated.Outs/3}.${yearly_cumulated.Outs%3}`, yearly_cumulated.PA, yearly_cumulated.H, yearly_cumulated.ER, yearly_cumulated.HR, yearly_cumulated.BB, yearly_cumulated.K, getDecimalData(yearly_cumulated.H, yearly_cumulated.AB, 3, '-')]})
    standard.push({title: 'Total', data: ['高中累計成績', total.G, total.GS, getDecimalData(total.ER * 27, total.Outs, 2, '-'), `${total.Outs/3}.${total.Outs%3}`, total.PA, total.H, total.ER, total.HR, total.BB, total.K, getDecimalData(total.H, total.AB, 3, '-')]})
    advanced.push({title: current_year, data: ['年度成績', getDecimalData(yearly_cumulated.K * 27, yearly_cumulated.Outs, 1, '-'), getDecimalData(yearly_cumulated.BB * 27, yearly_cumulated.Outs, 1, '-'), getDecimalData(yearly_cumulated.K, yearly_cumulated.BB, 2, '-'), getPercentageData(yearly_cumulated.K, yearly_cumulated.PA, 2, '-'), getPercentageData(yearly_cumulated.BB, yearly_cumulated.PA, 2, '-'), getPercentageData(yearly_cumulated.K-yearly_cumulated.BB, yearly_cumulated.PA, 2, '-'), getDecimalData(yearly_cumulated.H, yearly_cumulated.AB, 3, '-'), getDecimalData(yearly_cumulated.OnBase*3, yearly_cumulated.Outs, 2, '-'), getDecimalData(yearly_cumulated.H, yearly_cumulated.InPlays, 2, '-')]})
    advanced.push({title: 'Total', data: ['高中累計成績', getDecimalData(total.K * 27, total.Outs, 1, '-'), getDecimalData(total.BB * 27, total.Outs, 1, '-'), getDecimalData(total.K, total.BB, 2, '-'), getPercentageData(total.K, total.PA, 2, '-'), getPercentageData(total.BB, total.PA, 2, '-'), getPercentageData(total.K-total.BB, total.PA, 2, '-'), getDecimalData(total.H, total.AB, 3, '-'), getDecimalData(total.OnBase*3, total.Outs, 2, '-'), getDecimalData(total.H, total.InPlays, 2, '-')]})
  }
  // discipline
  // columns -> year, gtype, oswing, zswing, swing, ocontact, zcontact, contact, whiff, zone, swstr, cstr, csw
  let discipline = []
  let total = { Z_Swing: 0, O_Swing: 0, OZone: 0, Zone: 0, O_Contact: 0, Z_Contact: 0, Whiff: 0, C_Strike: 0, Strike: 0, Pitches: 0, PA: 0 }
  let yearly_cumulated = { Z_Swing: 0, O_Swing: 0, OZone: 0, Zone: 0, O_Contact: 0, Z_Contact: 0, Whiff: 0, C_Strike: 0, Strike: 0, Pitches: 0, PA: 0 }, current_year = data[0].Year
  for (const row of data) {
    if (row.Year !== current_year) {
      discipline.push({title: current_year, data: [
        '年度成績', getPercentageData(yearly_cumulated.O_Swing, yearly_cumulated.OZone, 1), getPercentageData(yearly_cumulated.Z_Swing, yearly_cumulated.Zone, 1), getPercentageData(yearly_cumulated.O_Swing+yearly_cumulated.Z_Swing, yearly_cumulated.Pitches, 1), 
        getPercentageData(yearly_cumulated.O_Contact, yearly_cumulated.O_Swing, 1), getPercentageData(yearly_cumulated.Z_Contact, yearly_cumulated.Z_Swing, 1), getPercentageData(yearly_cumulated.O_Contact+yearly_cumulated.Z_Contact, yearly_cumulated.O_Swing+yearly_cumulated.Z_Swing, 1),
        getPercentageData(yearly_cumulated.Whiff, yearly_cumulated.O_Swing+yearly_cumulated.Z_Swing, 1), getPercentageData(yearly_cumulated.Zone, yearly_cumulated.Pitches, 1), getPercentageData(yearly_cumulated.O_Swing+yearly_cumulated.Z_Swing, yearly_cumulated.Strike, 1),
        getPercentageData(yearly_cumulated.C_Strike, yearly_cumulated.Strike, 1), getPercentageData(yearly_cumulated.C_Strike+yearly_cumulated.Whiff, yearly_cumulated.Pitches, 1)
      ]})
      current_year = row.Year
      yearly_cumulated = { Z_Swing: 0, O_Swing: 0, OZone: 0, Zone: 0, O_Contact: 0, Z_Contact: 0, Whiff: 0, C_Strike: 0, Strike: 0, Pitches: 0, PA: 0 }
    }
    discipline.push({title: row.Year, data: [
      row.GameType, getPercentageData(row.O_Swing, row.OZone, 1), getPercentageData(row.Z_Swing, row.Zone, 1), getPercentageData(row.O_Swing+row.Z_Swing, row.Pitches, 1), 
      getPercentageData(row.O_Contact, row.O_Swing, 1), getPercentageData(row.Z_Contact, row.Z_Swing, 1), getPercentageData(row.O_Contact+row.Z_Contact, row.O_Swing+row.Z_Swing, 1),
      getPercentageData(row.Whiff, row.O_Swing+row.Z_Swing, 1), getPercentageData(row.Zone, row.Pitches, 1), getPercentageData(row.O_Swing+row.Z_Swing, row.Strike, 1),
      getPercentageData(row.C_Strike, row.Strike, 1), getPercentageData(row.C_Strike+row.Whiff, row.Pitches, 1)
    ]})
    for (const key in total) {
      total[key] += row[key]
      yearly_cumulated[key] += row[key]
    }
  }
  discipline.push({title: current_year, data: [
    '年度成績', getPercentageData(yearly_cumulated.O_Swing, yearly_cumulated.OZone, 1), getPercentageData(yearly_cumulated.Z_Swing, yearly_cumulated.Zone, 1), getPercentageData(yearly_cumulated.O_Swing+yearly_cumulated.Z_Swing, yearly_cumulated.Pitches, 1), 
    getPercentageData(yearly_cumulated.O_Contact, yearly_cumulated.O_Swing, 1), getPercentageData(yearly_cumulated.Z_Contact, yearly_cumulated.Z_Swing, 1), getPercentageData(yearly_cumulated.O_Contact+yearly_cumulated.Z_Contact, yearly_cumulated.O_Swing+yearly_cumulated.Z_Swing, 1),
    getPercentageData(yearly_cumulated.Whiff, yearly_cumulated.O_Swing+yearly_cumulated.Z_Swing, 1), getPercentageData(yearly_cumulated.Zone, yearly_cumulated.Pitches, 1), getPercentageData(yearly_cumulated.O_Swing+yearly_cumulated.Z_Swing, yearly_cumulated.Strike, 1),
    getPercentageData(yearly_cumulated.C_Strike, yearly_cumulated.Strike, 1), getPercentageData(yearly_cumulated.C_Strike+yearly_cumulated.Whiff, yearly_cumulated.Pitches, 1)
  ]})
  discipline.push({title: 'Total', data: [
    '高中累計成績', getPercentageData(total.O_Swing, total.OZone, 1), getPercentageData(total.Z_Swing, total.Zone, 1), getPercentageData(total.O_Swing+total.Z_Swing, total.Pitches, 1), 
    getPercentageData(total.O_Contact, total.O_Swing, 1), getPercentageData(total.Z_Contact, total.Z_Swing, 1), getPercentageData(total.O_Contact+total.Z_Contact, total.O_Swing+total.Z_Swing, 1),
    getPercentageData(total.Whiff, total.O_Swing+total.Z_Swing, 1), getPercentageData(total.Zone, total.Pitches, 1), getPercentageData(total.O_Swing+total.Z_Swing, total.Strike, 1),
    getPercentageData(total.C_Strike, total.Strike, 1), getPercentageData(total.C_Strike+total.Whiff, total.Pitches, 1)
  ]})
  // batted ball
  //columns -> gb/fb, gb, ld, fb, iffb, pull, cent, oppo, soft, med, hard
  let batted_ball = []
  total = { InPlays: 0, G_p: 0, L_p: 0, F_p: 0, IFFB: 0, pull: 0, cent: 0, oppo: 0, Soft_p: 0, Med_p: 0, Hard_p: 0 }
  yearly_cumulated = { InPlays: 0, G_p: 0, L_p: 0, F_p: 0, IFFB: 0, pull: 0, cent: 0, oppo: 0, Soft_p: 0, Med_p: 0, Hard_p: 0 }
  current_year = data[0].Year
  for (const row of data) {
    if (row.Year !== current_year) {
      batted_ball.push({title: current_year, data: [
        '年度成績', getDecimalData(yearly_cumulated.G_p, yearly_cumulated.F_p, 2), getPercentageData(yearly_cumulated.G_p, yearly_cumulated.InPlays, 1), getPercentageData(yearly_cumulated.L_p, yearly_cumulated.InPlays, 1),
        getPercentageData(yearly_cumulated.F_p, yearly_cumulated.InPlays, 1), getPercentageData(yearly_cumulated.IFFB, yearly_cumulated.InPlays, 1), getPercentageData(yearly_cumulated.pull, yearly_cumulated.InPlays, 1),
        getPercentageData(yearly_cumulated.cent, yearly_cumulated.InPlays, 1), getPercentageData(yearly_cumulated.oppo, yearly_cumulated.InPlays, 1), getPercentageData(yearly_cumulated.Soft_p, yearly_cumulated.InPlays, 1),
        getPercentageData(yearly_cumulated.Med_p, yearly_cumulated.InPlays, 1), getPercentageData(yearly_cumulated.Hard_p, yearly_cumulated.InPlays, 1)
      ]})
      current_year = row.Year
      yearly_cumulated = { InPlays: 0, G_p: 0, L_p: 0, F_p: 0, IFFB: 0, pull: 0, cent: 0, oppo: 0, Soft_p: 0, Med_p: 0, Hard_p: 0 }
    }
    batted_ball.push({title: row.Year, data: [
      row.GameType, getDecimalData(parseFloat(row.G_p), parseFloat(row.F_p), 2), `${row.G_p}%`, `${row.L_p}%`, `${row.F_p}%`, `${row.IFFB}%`, `${row.pull}%`, `${row.cent}%`, `${row.oppo}%`
      , `${row.Soft_p}%`, `${row.Med_p}%`, `${row.Hard_p}%`
    ]})
    for (const key in total) {
      if (key === 'InPlays') {
        total[key] += row[key]
        yearly_cumulated[key] += row[key]
      } else {
        total[key] += Math.round(row[key] * row.InPlays / 100)
        yearly_cumulated[key] += Math.round(row[key] * row.InPlays / 100)
      }
    }
  }
  batted_ball.push({title: current_year, data: [
    '年度成績', getDecimalData(yearly_cumulated.G_p, yearly_cumulated.F_p, 2), getPercentageData(yearly_cumulated.G_p, yearly_cumulated.InPlays, 1), getPercentageData(yearly_cumulated.L_p, yearly_cumulated.InPlays, 1),
    getPercentageData(yearly_cumulated.F_p, yearly_cumulated.InPlays, 1), getPercentageData(yearly_cumulated.IFFB, yearly_cumulated.InPlays, 1), getPercentageData(yearly_cumulated.pull, yearly_cumulated.InPlays, 1),
    getPercentageData(yearly_cumulated.cent, yearly_cumulated.InPlays, 1), getPercentageData(yearly_cumulated.oppo, yearly_cumulated.InPlays, 1), getPercentageData(yearly_cumulated.Soft_p, yearly_cumulated.InPlays, 1),
    getPercentageData(yearly_cumulated.Med_p, yearly_cumulated.InPlays, 1), getPercentageData(yearly_cumulated.Hard_p, yearly_cumulated.InPlays, 1)
  ]})
  batted_ball.push({title: 'Total', data: [
    '高中累計成績', getDecimalData(total.G_p, total.F_p, 2), getPercentageData(total.G_p, total.InPlays, 1), getPercentageData(total.L_p, total.InPlays, 1),
    getPercentageData(total.F_p, total.InPlays, 1), getPercentageData(total.IFFB, total.InPlays, 1), getPercentageData(total.pull, total.InPlays, 1),
    getPercentageData(total.cent, total.InPlays, 1), getPercentageData(total.oppo, total.InPlays, 1), getPercentageData(total.Soft_p, total.InPlays, 1),
    getPercentageData(total.Med_p, total.InPlays, 1), getPercentageData(total.Hard_p, total.InPlays, 1)]})

  return { standard, discipline, advanced, batted_ball }
}

const extractBallCountData = (data, target, isBatter=false) => {
  // console.log(data, target)
  let pitchTypeSet = new Set()
  let output = {
    left: {'0-0': {}, '1-0': {}, '1-1': {}, '1-2': {}, '1-3': {}, '0-1': {}, '0-2': {}, '0-3': {}, '2-0': {}, '2-1': {}, '2-2': {}, '2-3': {}},
    right: {'0-0': {}, '1-0': {}, '1-1': {}, '1-2': {}, '1-3': {}, '0-1': {}, '0-2': {}, '0-3': {}, '2-0': {}, '2-1': {}, '2-2': {}, '2-3': {}},
    all: {'0-0': {}, '1-0': {}, '1-1': {}, '1-2': {}, '1-3': {}, '0-1': {}, '0-2': {}, '0-3': {}, '2-0': {}, '2-1': {}, '2-2': {}, '2-3': {}}
  }

  let count = {
    left: {'0-0': 0, '1-0': 0, '1-1': 0, '1-2': 0, '1-3': 0, '0-1': 0, '0-2': 0, '0-3': 0, '2-0': 0, '2-1': 0, '2-2': 0, '2-3': 0},
    right: {'0-0': 0, '1-0': 0, '1-1': 0, '1-2': 0, '1-3': 0, '0-1': 0, '0-2': 0, '0-3': 0, '2-0': 0, '2-1': 0, '2-2': 0, '2-3': 0},
    all: {'0-0': 0, '1-0': 0, '1-1': 0, '1-2': 0, '1-3': 0, '0-1': 0, '0-2': 0, '0-3': 0, '2-0': 0, '2-1': 0, '2-2': 0, '2-3': 0}
  }
  // console.log(data)
  for (let p of data) {
    if (['', 'UN', '?', null].includes(p.TaggedPitchType)) continue
    if (isBatter && !swing_set.includes(p.PitchCode)) continue 
    let bctag = `${p.Strikes}-${p.Balls}`
    let side = parseInt(p[target])===1? 'left':'right'
    pitchTypeSet.add(p.TaggedPitchType)
    if (output[side][bctag][p.TaggedPitchType] === undefined) output[side][bctag][p.TaggedPitchType] = []
    if (output.all[bctag][p.TaggedPitchType] === undefined) output.all[bctag][p.TaggedPitchType] = []
    if (!(invalid_set.includes(p.APP_KZoneY) && invalid_set.includes(p.APP_KZoneZ))) {
      output[side][bctag][p.TaggedPitchType].push({x: p.APP_KZoneY, y: p.APP_KZoneZ, time: new Date(p.Date)})
      output.all[bctag][p.TaggedPitchType].push({x: p.APP_KZoneY, y: p.APP_KZoneZ, time: new Date(p.Date)})
    }
    count[side][bctag]++
    count.all[bctag]++
  }

  let usage = {
    left: {'0-0': [], '1-0': [], '1-1': [], '1-2': [], '1-3': [], '0-1': [], '0-2': [], '0-3': [], '2-0': [], '2-1': [], '2-2': [], '2-3': []},
    right: {'0-0': [], '1-0': [], '1-1': [], '1-2': [], '1-3': [], '0-1': [], '0-2': [], '0-3': [], '2-0': [], '2-1': [], '2-2': [], '2-3': []},
    all: {'0-0': [], '1-0': [], '1-1': [], '1-2': [], '1-3': [], '0-1': [], '0-2': [], '0-3': [], '2-0': [], '2-1': [], '2-2': [], '2-3': []}
  }

  for (const s in output) {
    for (const c in output[s]) {
      for (const t in output[s][c]) {
        usage[s][c].push({tag: t, usage: getDecimalData(output[s][c][t].length*100, count[s][c], 0)})
      }
    }
  }

  pitchTypeSet = Array.from(pitchTypeSet)
  // console.log(output)
  return { zone: output, usage, pitchTypeSet }
}

export const extractZoneData = (data, type) => {
  let pitch_n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let swing_n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let whiff_n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let hr_n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let h_n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let single_n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let double_n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let triple_n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let gb_n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let ld_n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let fb_n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let pu_n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let ab_dn = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let tb_n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let woba_n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let pa_dn = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let ip_sum_arr = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let avg = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let slg = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let iso = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let pitch_n_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let swing_n_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let whiff_n_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let hr_n_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let h_n_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let single_n_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let double_n_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let triple_n_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let gb_n_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let ld_n_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let fb_n_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let pu_n_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let ab_dn_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let tb_n_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let woba_n_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let pa_dn_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let ip_sum_arr_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let avg_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let slg_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let iso_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let pitch_n_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let swing_n_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let whiff_n_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let hr_n_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let h_n_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let single_n_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let double_n_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let triple_n_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let gb_n_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let ld_n_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let fb_n_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let pu_n_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let ab_dn_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let tb_n_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let woba_n_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let pa_dn_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let ip_sum_arr_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let avg_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let slg_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let iso_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let k_n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let k_n_l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let k_n_r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let total_pitch = 0, total_left = 0, total_right = 0
  const side = type==='pitcher'? 'BatS':'PT'
  for (const p of data) {
    if (["", 'UN', '?', null].includes(p.TaggedPitchType)) continue
    let zoneIdx = parseInt(p.OZone) > 10? parseInt(p.OZone)-2:parseInt(p.OZone)-1
    total_pitch++
    pitch_n[zoneIdx]++
    if (parseInt(p[side]) === 0) {
      total_right++
      pitch_n_r[zoneIdx]++
    } else {
      total_left++
      pitch_n_l[zoneIdx]++
    }
    if (p.PA_Result !== undefined && p.PA_Result[0] !== undefined) {
      pa_dn[zoneIdx]++
      if (parseInt(p[side]) === 0) {
        pa_dn_r[zoneIdx]++
      } else {
        pa_dn_l[zoneIdx]++
      }
      if (p.PA_Result === 'HBP') {
        woba_n[zoneIdx] += 0.7846
        if (parseInt(p[side]) === 0) {
          woba_n_r[zoneIdx] += 0.7846
        } else {
          woba_n_l[zoneIdx] += 0.7846
        }
      }
      if (!non_ab_set.includes(p.PA_Result)) {
        ab_dn[zoneIdx]++
        if (parseInt(p[side]) === 0) {
          ab_dn_r[zoneIdx]++
        } else {
          ab_dn_l[zoneIdx]++
        }
      }
    }
    if (swing_set.includes(p.PitchCode)) {
      swing_n[zoneIdx]++
      if (parseInt(p[side]) === 0) {
        swing_n_r[zoneIdx]++
      } else {
        swing_n_l[zoneIdx]++
      }
      if (p.PitchCode === 'Strk-S') {
        whiff_n[zoneIdx]++
        if (parseInt(p[side]) === 0) {
          whiff_n_r[zoneIdx]++
        } else {
          whiff_n_l[zoneIdx]++
        }
      }
    }
    if (hit_set.includes(p.PA_Result)) {
      h_n[zoneIdx]++
      if (parseInt(p[side]) === 0) {
        h_n_r[zoneIdx]++
      } else {
        h_n_l[zoneIdx]++
      }
      if (p.PA_Result === '1B') {
        single_n[zoneIdx]++
        tb_n[zoneIdx]++
        woba_n[zoneIdx] += 0.9578
        if (parseInt(p[side]) === 0) {
          single_n_r[zoneIdx]++
          tb_n_r[zoneIdx]++
          woba_n_r[zoneIdx] += 0.9578
        } else {
          single_n_l[zoneIdx]++
          tb_n_l[zoneIdx]++
          woba_n_l[zoneIdx] += 0.9578
        }
      } else if (p.PA_Result === '2B') {
        double_n[zoneIdx]++
        tb_n[zoneIdx] += 2
        woba_n[zoneIdx] += 1.3347
        if (parseInt(p[side]) === 0) {
          double_n_r[zoneIdx]++
          tb_n_r[zoneIdx] += 2
          woba_n_r[zoneIdx] += 1.3347
        } else {
          double_n_l[zoneIdx]++
          tb_n_l[zoneIdx] += 2
          woba_n_l[zoneIdx] += 1.3347
        }
      } else if (p.PA_Result === '3B') {
        triple_n[zoneIdx]++
        tb_n[zoneIdx] += 3
        woba_n[zoneIdx] += 1.6917
        if (parseInt(p[side]) === 0) {
          triple_n_r[zoneIdx]++
          tb_n_r[zoneIdx] += 3
          woba_n_r[zoneIdx] += 1.6917
        } else {
          triple_n_l[zoneIdx]++
          tb_n_l[zoneIdx] += 3
          woba_n_l[zoneIdx] += 1.6917
        }
      } else {
        hr_n[zoneIdx]++
        tb_n[zoneIdx] += 4
        woba_n[zoneIdx] += 2.1009
        if (parseInt(p[side]) === 0) {
          hr_n_r[zoneIdx]++
          tb_n_r[zoneIdx] += 4
          woba_n_r[zoneIdx] += 2.1009
        } else {
          hr_n_l[zoneIdx]++
          tb_n_l[zoneIdx] += 4
          woba_n_l[zoneIdx] += 2.1009
        }
      }
    }
    if (nibb_set.includes(p.PA_Result)) {
      woba_n[zoneIdx] += 0.7705
      if (parseInt(p[side]) === 0) {
        woba_n_r[zoneIdx] += 0.7705
      } else {
        woba_n_l[zoneIdx] += 0.7705
      }
    }
    // if (error_set.includes(p.PA_Result)) {
    //   woba_n[zoneIdx] += 0.92
    //   if (parseInt(p[side]) === 0) {
    //     woba_n_r[zoneIdx] += 0.92
    //   } else {
    //     woba_n_l[zoneIdx] += 0.92
    //   }
    // }
    if (k_set.includes(p.PA_Result)) {
      k_n[zoneIdx]++
      if (parseInt(p[side]) === 0) {
        k_n_r[zoneIdx]++
      } else {
        k_n_l[zoneIdx]++
      }
    }
    if (p.PitchCode === 'Inplay' || p.PitchCode === 'In-Play') {
      if (p.HitType === 'GROUND') {
        gb_n[zoneIdx]++
        if (parseInt(p[side]) === 0) {
          gb_n_r[zoneIdx]++
        } else {
          gb_n_l[zoneIdx]++
        }
      } else if (p.HitType === 'LINE') {
        ld_n[zoneIdx]++
        if (parseInt(p[side]) === 0) {
          ld_n_r[zoneIdx]++
        } else {
          ld_n_l[zoneIdx]++
        }
      } else if (p.HitType === 'FLYB') {
        fb_n[zoneIdx]++
        if (parseInt(p[side]) === 0) {
          fb_n_r[zoneIdx]++
        } else {
          fb_n_l[zoneIdx]++
        }
      } else if (p.HitType === 'POPB') {
        pu_n[zoneIdx]++
        if (parseInt(p[side]) === 0) {
          pu_n_r[zoneIdx]++
        } else {
          pu_n_l[zoneIdx]++
        }
      }
    }
  }
  for (let i=0; i<13; i++) {
    whiff_n[i] = getDecimalData(whiff_n[i]*100, swing_n[i], 0, 0)
    whiff_n_r[i] = getDecimalData(whiff_n_r[i]*100, swing_n_r[i], 0, 0)
    whiff_n_l[i] = getDecimalData(whiff_n_l[i]*100, swing_n_l[i], 0, 0)
  }
  for (let i=0; i<13; i++) {
    swing_n[i] = getDecimalData(swing_n[i]*100, pitch_n[i], 1, 0)
    swing_n_r[i] = getDecimalData(swing_n_r[i]*100, pitch_n_r[i], 1, 0)
    swing_n_l[i] = getDecimalData(swing_n_l[i]*100, pitch_n_l[i], 1, 0)
  }
  for (let i=0; i<13; i++) {
    pitch_n[i] = getDecimalData(pitch_n[i]*100, total_pitch, 1, 0)
    pitch_n_r[i] = getDecimalData(pitch_n_r[i]*100, total_right, 1, 0)
    pitch_n_l[i] = getDecimalData(pitch_n_l[i]*100, total_left, 1, 0)
  }
  for (let i=0; i<13; i++) {
    ip_sum_arr[i] = gb_n[i] + ld_n[i] + fb_n[i] + pu_n[i]
    ip_sum_arr_r[i] = gb_n_r[i] + ld_n_r[i] + fb_n_r[i] + pu_n_r[i]
    ip_sum_arr_l[i] = gb_n_l[i] + ld_n_l[i] + fb_n_l[i] + pu_n_l[i]
  }
  for (let i=0; i<13; i++) {
    gb_n[i] = getDecimalData(gb_n[i]*100, ip_sum_arr[i], 0, 0)
    ld_n[i] = getDecimalData(ld_n[i]*100, ip_sum_arr[i], 0, 0)
    fb_n[i] = getDecimalData(fb_n[i]*100, ip_sum_arr[i], 0, 0)
    pu_n[i] = getDecimalData(pu_n[i]*100, ip_sum_arr[i], 0, 0)
    gb_n_r[i] = getDecimalData(gb_n_r[i]*100, ip_sum_arr_r[i], 0, 0)
    ld_n_r[i] = getDecimalData(ld_n_r[i]*100, ip_sum_arr_r[i], 0, 0)
    fb_n_r[i] = getDecimalData(fb_n_r[i]*100, ip_sum_arr_r[i], 0, 0)
    pu_n_r[i] = getDecimalData(pu_n_r[i]*100, ip_sum_arr_r[i], 0, 0)
    gb_n_l[i] = getDecimalData(gb_n_l[i]*100, ip_sum_arr_l[i], 0, 0)
    ld_n_l[i] = getDecimalData(ld_n_l[i]*100, ip_sum_arr_l[i], 0, 0)
    fb_n_l[i] = getDecimalData(fb_n_l[i]*100, ip_sum_arr_l[i], 0, 0)
    pu_n_l[i] = getDecimalData(pu_n_l[i]*100, ip_sum_arr_l[i], 0, 0)
  }
  for (let i=0; i<13; i++) {
    woba_n[i] = getDecimalData(woba_n[i], pa_dn[i], 3, '0.000')
    k_n[i] = getDecimalData(k_n[i]*100, pa_dn[i], 0, 0)
    avg[i] = getDecimalData(h_n[i], ab_dn[i], 3, '0.000')
    slg[i] = getDecimalData(tb_n[i], ab_dn[i], 3, '0.000')
    iso[i] = getDecimalData(tb_n[i] - h_n[i], ab_dn[i], 3, '0.000')
    woba_n_r[i] = getDecimalData(woba_n_r[i], pa_dn_r[i], 3, '0.000')
    k_n_r[i] = getDecimalData(k_n_r[i]*100, pa_dn_r[i], 0, 0)
    avg_r[i] = getDecimalData(h_n_r[i], ab_dn_r[i], 3, '0.000')
    slg_r[i] = getDecimalData(tb_n_r[i], ab_dn_r[i], 3, '0.000')
    iso_r[i] = getDecimalData(tb_n_r[i] - h_n_r[i], ab_dn_r[i], 3, '0.000')
    woba_n_l[i] = getDecimalData(woba_n_l[i], pa_dn_l[i], 3, '0.000')
    k_n_l[i] = getDecimalData(k_n_l[i]*100, pa_dn_l[i], 0, 0)
    avg_l[i] = getDecimalData(h_n_l[i], ab_dn_l[i], 3, '0.000')
    slg_l[i] = getDecimalData(tb_n_l[i], ab_dn_l[i], 3, '0.000')
    iso_l[i] = getDecimalData(tb_n_l[i] - h_n_l[i], ab_dn_l[i], 3, '0.000')
  }

  return {
    all: {
      pitch: pitch_n, swing: swing_n, whiff: whiff_n, h: h_n, hr: hr_n, single: single_n, double: double_n, triple: triple_n,
      ground: gb_n, line: ld_n, fly: fb_n, pop: pu_n, avg: avg, slg: slg, iso: iso, woba: woba_n, k: k_n
    },
    right: {
      pitch: pitch_n_r, swing: swing_n_r, whiff: whiff_n_r, h: h_n_r, hr: hr_n_r, single: single_n_r, double: double_n_r, triple: triple_n_r,
      ground: gb_n_r, line: ld_n_r, fly: fb_n_r, pop: pu_n_r, avg: avg_r, slg: slg_r, iso: iso_r, woba: woba_n_r, k: k_n_r
    },
    left: {
      pitch: pitch_n_l, swing: swing_n_l, whiff: whiff_n_l, h: h_n_l, hr: hr_n_l, single: single_n_l, double: double_n_l, triple: triple_n_l,
      ground: gb_n_l, line: ld_n_l, fly: fb_n_l, pop: pu_n_l, avg: avg_l, slg: slg_l, iso: iso_l, woba: woba_n_l, k: k_n_l
    }
  }
}

const extractZoneDataBySituation = (data) => {
  let output = {
    inplay: [], whiff: [], watch: [], hit: [], ptSet: new Set()
  }
  for (const p of data) {
    if (['', 'UN', '?', null].includes(p.TaggedPitchType)) continue
    if (invalid_set.includes(p.APP_KZoneY) && invalid_set.includes(p.APP_KZoneZ)) continue
    let wrappedEntries = { x: parseFloat(p.APP_KZoneY), y: parseFloat(p.APP_KZoneZ), tag: p.TaggedPitchType, count: p.BS, pside: p.PT, bside: p.BatS }
    if (p.PitchCode === 'Strk-S') {
      output.whiff.push(wrappedEntries)
      output.ptSet.add(p.TaggedPitchType)
    }
    if (p.PitchCode === 'Strk-C') {
      output.watch.push(wrappedEntries)
      output.ptSet.add(p.TaggedPitchType)
    }
    if (p.PitchCode === 'In-Play' || p.PitchCode === 'Inplay') {
      output.inplay.push(wrappedEntries)
      output.ptSet.add(p.TaggedPitchType)
      if (hit_set.includes(p.PA_Result)) {
        output.hit.push(wrappedEntries)
      }
    }
  }
  output.ptSet = Array.from(output.ptSet)
  return output
}

const extractZoneAreaData = (data) => {
  let output = {
    heart: {swing: [], watch: []}, shadow:  {swing: [], watch: []}, chase: {swing: [], watch: []},  waste: {swing: [], watch: []}
  }
  for (const p of data) {
    let x = parseFloat(p.APP_KZoneY), y = parseFloat(p.APP_KZoneZ)
    if ((y <= 38 && y >= 22) && (x >= -6.7 && x <= 6.7)) {
      if (swing_set.includes(p.PitchCode)) {
        output.heart.swing.push({tag: p.TaggedPitchType, count: p.BS, pside: p.PT, bside: p.BatS})
      } else {
        output.heart.watch.push({tag: p.TaggedPitchType, count: p.BS, pside: p.PT, bside: p.BatS})
      }
    } else if ((y <= 46 && y >= 14) && (x >= -13.3 && x <= 13.3)) {
      if (swing_set.includes(p.PitchCode)) {
        output.shadow.swing.push({tag: p.TaggedPitchType, count: p.BS, pside: p.PT, bside: p.BatS})
      } else {
        output.shadow.watch.push({tag: p.TaggedPitchType, count: p.BS, pside: p.PT, bside: p.BatS})
      }
    } else if ((y <= 54 && y >= 6) && (x >= -20 && x <= 20)) {
      if (swing_set.includes(p.PitchCode)) {
        output.chase.swing.push({tag: p.TaggedPitchType, count: p.BS, pside: p.PT, bside: p.BatS})
      } else {
        output.chase.watch.push({tag: p.TaggedPitchType, count: p.BS, pside: p.PT, bside: p.BatS})
      }
    } else {
      if (swing_set.includes(p.PitchCode)) {
        output.waste.swing.push({tag: p.TaggedPitchType, count: p.BS, pside: p.PT, bside: p.BatS})
      } else {
        output.waste.watch.push({tag: p.TaggedPitchType, count: p.BS, pside: p.PT, bside: p.BatS})
      }
    }
  }

  return output
}

const extractHitLocationData = (data) => {
  // console.log(data)
  let fieldData = [], groupByLabel = {}
  for (const p of data) {
    if ((p.PitchCode === 'Inplay' || p.PitchCode === 'In-Play') && !(invalid_set.includes(p.LocX) && invalid_set.includes(p.LocY))) {
      let label = hit_set.includes(p.PA_Result)? 'H-'+ p.HitType : 'OUT-' + p.HitType
      if (groupByLabel[label] === undefined) groupByLabel[label] = []
      groupByLabel[label].push({label, g: p.GameNo, inn: p.Inning, p: p.Pitcher, b: p.Batter, pr: p.PA_Result, x: parseFloat(p.LocX), y: parseFloat(p.LocY)})
    }
  }

  for (const l in groupByLabel) {
    fieldData.push({
      label: l,
      data: groupByLabel[l],
      ...hitLocationColorMap[l],
    })
  }

  return {datasets: fieldData}
}

const extractHeapMapData = (data) => {
  let output = []
  for (const p of data) {
    output.push({x: parseFloat(p.APP_KZoneY), y: parseFloat(p.APP_KZoneZ), s: p.Strikes, b: p.Balls, zn: p.OZone, tag: p.TaggedPitchType, side: p.BatS, code: p.PitchCode, res: p.PA_Result})
  }
  return output
}

const extractHitHeatMap = (data) => {
  let output = {}
  for (const p of data) {
    if (!hit_set.includes(p.PA_Result)) continue
    let label = `${p.Balls}-${p.Strikes}`
    if (output[label] === undefined) {
      output[label] = []
    }
    output[label].push({x: parseFloat(p.APP_KZoneY), y: parseFloat(p.APP_KZoneZ), value: Math.min(3, hit_set.indexOf(p.PA_Result))+1})
  }

  return output
}

const initArray = (len, idx=false) => {
  let arr = []
  for (let i=1; i<=len; i++) {
    if (!idx) arr.push({x: i, y: null})
    else arr.push(i)
  }
  return arr
}

const extractBatterScoreLogData = (data) => {
  const currentTime = new Date()
  const properEndDay = new Date(2022, 9, 26)
  let timegap = Math.floor((Math.min(currentTime, properEndDay) - OpenindDayDate) / (24 * 60 * 60 * 1000))
  let weekgap = Math.floor(timegap / 14)
  let output = [{
    avg: initArray(weekgap),
    woba: initArray(weekgap),
    iso: initArray(weekgap),
    babip: initArray(weekgap),
    obp: initArray(weekgap),
    len: 0
  }, {
    zonec: initArray(weekgap),
    zones: initArray(weekgap),
    whiff: initArray(weekgap),
    oswing: initArray(weekgap),
    kp: initArray(weekgap),
    bbp: initArray(weekgap),
    len: 0
  }]
  // console.log(data)
  for (let w of data) {
    output[0].len++
    output[1].len++
    let tidx = w.time_idx-1
    output[0].avg[tidx].y = w.Avg
    output[0].woba[tidx].y = w.wOBA
    output[0].iso[tidx].y = w.ISO
    output[0].babip[tidx].y = w.BABIP
    output[0].obp[tidx].y = w.OBP
    output[1].whiff[tidx].y = w.Whiff
    output[1].oswing[tidx].y = w.Chase
    output[1].kp[tidx].y = w.K_P
    output[1].bbp[tidx].y = w.BB_P
    output[1].zonec[tidx].y = w.Zcon
    output[1].zones[tidx].y = w.ZSw
  }
  // console.log(data, output)
  return output
}

const extractPitcherPitchTrendData = (data) => {
  let game = {}, arsenal = new Set()
  for (const d of data) {
    if (['', 'UN', '?', null].includes(d.TaggedPitchType)) continue
    if (game[d.Date] === undefined) game[d.Date] = { pcount: 0 }
    if (game[d.Date][d.TaggedPitchType] === undefined) game[d.Date][d.TaggedPitchType] = { count: 0, vsum: 0, high: 0, low: 200, vcount: 0 }
    arsenal.add(d.TaggedPitchType)
    const v = parseFloat(d.APP_VeloRel)
    game[d.Date].pcount++
    game[d.Date][d.TaggedPitchType].count++
    if (!isNaN(v)) {
      game[d.Date][d.TaggedPitchType].vcount++
      game[d.Date][d.TaggedPitchType].vsum += v
      game[d.Date][d.TaggedPitchType].high = Math.max(game[d.Date][d.TaggedPitchType].high, v)
      game[d.Date][d.TaggedPitchType].low = Math.min(game[d.Date][d.TaggedPitchType].low, v)
    }
  }
  for (const dt in game) {
    for (const pt in game[dt]) {
      if (pt === 'pcount') continue
      game[dt][pt].usage = getDecimalData(game[dt][pt].count * 100, game[dt].pcount, 1, '-')
      game[dt][pt].avg_velo = getDecimalData(game[dt][pt].vsum, game[dt][pt].vcount, 1, '---')
      if (game[dt][pt].high === 200) game[dt][pt].high = '---'
      if (game[dt][pt].low === 0) game[dt][pt].low = '---'
    }
  }

  return { arsenal, game }
}

const extractPitcherSequenceData = (data, side='all') => {
  const call_key = { 'Ball': 'ball', 'Strk-S': 'whiff', 'Strk-C': 'call_strike', 'Foul': 'foul' }
  let sequence = { pseq: { }, cseq: { firstp: {count: 0}, ahead: {count: 0}, behind: {count: 0}, even: {count: 0}, full: {count: 0} }, rseq: { ball: {count: 0}, call_strike: {count: 0}, whiff: {count: 0}, foul: {count: 0} } }
  let first_p = true, current_plate = -1, last_type = "", last_call = ""
  let arsenal = {count: 0}
  for (const p of data) {
    if (side !== 'all' && parseInt(p.BatS) !== side) continue

    if (p.plate_id !== current_plate) {
      current_plate = p.plate_id
      first_p = true
    }
    if (first_p) {
      sequence.cseq.firstp.count++
      if (sequence.cseq.firstp[p.TaggedPitchType] === undefined) sequence.cseq.firstp[p.TaggedPitchType] = 0
      sequence.cseq.firstp[p.TaggedPitchType]++
    } else {
      // result sequence
      if (call_key[last_call] !== undefined) {
        if (sequence.rseq[call_key[last_call]][p.TaggedPitchType] === undefined) sequence.rseq[call_key[last_call]][p.TaggedPitchType] = 0
        sequence.rseq[call_key[last_call]][p.TaggedPitchType]++
        sequence.rseq[call_key[last_call]].count++
      }
      const s = parseInt(p.Strikes), b = parseInt(p.Balls)
      if (sequence.cseq.full[p.TaggedPitchType] === undefined) {
        sequence.cseq.full[p.TaggedPitchType] = 0
        sequence.cseq.ahead[p.TaggedPitchType] = 0
        sequence.cseq.behind[p.TaggedPitchType] = 0
        sequence.cseq.even[p.TaggedPitchType] = 0
      }
      // count sequence
      if (s === 2 && b === 3) {
        sequence.cseq.full.count++
        sequence.cseq.full[p.TaggedPitchType]++
      } else if (s > b) {
        sequence.cseq.ahead.count++
        sequence.cseq.ahead[p.TaggedPitchType]++
      } else if (s < b) {
        sequence.cseq.behind.count++
        sequence.cseq.behind[p.TaggedPitchType]++
      } else {
        sequence.cseq.even.count++
        sequence.cseq.even[p.TaggedPitchType]++
      }
      // pitch sequence
      if (sequence.pseq[last_type] === undefined) sequence.pseq[last_type] = { count: 0 }
      if (sequence.pseq[last_type][p.TaggedPitchType] === undefined) sequence.pseq[last_type][p.TaggedPitchType] = 0
      sequence.pseq[last_type][p.TaggedPitchType]++
      sequence.pseq[last_type].count++
    }
    first_p = false
    last_type = p.TaggedPitchType
    last_call = p.PitchCode
    if (arsenal[p.TaggedPitchType] === undefined) arsenal[p.TaggedPitchType] = 0
    arsenal[p.TaggedPitchType]++
  }
  arsenal = Object.keys(arsenal).filter((e)=>!["", "?", "UN", null, "count"].includes(e))
  for (const seq of ['pseq', 'cseq', 'rseq']) {
    for (const situation in sequence[seq]) {
      for (const ptype in sequence[seq][situation]) {
        if (ptype === 'count') continue
        sequence[seq][situation][ptype] = parseInt(getDecimalData(sequence[seq][situation][ptype]*100, sequence[seq][situation].count, 0, 0))
      }
    }
  }
  // console.log(sequence)
  return { sequence, arsenal }
}

export const extractPitchSequenceTableData = (data) => {
  let tables = { general: [], left: [], right: [] }
  let pdata = { 
    general: {total: {count: 0, fp: 0, ft: 0, ts: 0, pa: 0, pb: 0, risp: 0}}, 
    left: {total: {count: 0, '0-0': 0, '0-1': 0, '0-2': 0, '1-0': 0, '1-1': 0, '1-2': 0, '2-0': 0, '2-1': 0, '2-2': 0, '3-0': 0, '3-1': 0, '3-2': 0}}, 
    right: {total: {count: 0, '0-0': 0, '0-1': 0, '0-2': 0, '1-0': 0, '1-1': 0, '1-2': 0, '2-0': 0, '2-1': 0, '2-2': 0, '3-0': 0, '3-1': 0, '3-2': 0}}
  }
  for (const d of data) {
    if (['UN', 'OT', '', null].includes(d.TaggedPitchType)) continue
    if (pdata.general[d.TaggedPitchType] === undefined) {
      pdata.general[d.TaggedPitchType] = {count: 0, fp: 0, ft: 0, ts: 0, pa: 0, pb: 0, risp: 0, zone: 0, oswing: 0, ocount: 0, ab: 0, h: 0}
    }
    if (d.BatS === 0) {
      if (pdata.right[d.TaggedPitchType] === undefined) {
        pdata.right[d.TaggedPitchType] = {count: 0, '0-0': 0, '0-1': 0, '0-2': 0, '1-0': 0, '1-1': 0, '1-2': 0, '2-0': 0, '2-1': 0, '2-2': 0, '3-0': 0, '3-1': 0, '3-2': 0}
      }
      pdata.right.total.count++
      pdata.right.total[d.BS]++
      pdata.right[d.TaggedPitchType].count++
      pdata.right[d.TaggedPitchType][d.BS]++
    } else {
      if (pdata.left[d.TaggedPitchType] === undefined) {
        pdata.left[d.TaggedPitchType] = {count: 0, '0-0': 0, '0-1': 0, '0-2': 0, '1-0': 0, '1-1': 0, '1-2': 0, '2-0': 0, '2-1': 0, '2-2': 0, '3-0': 0, '3-1': 0, '3-2': 0}
      }
      pdata.left.total.count++
      pdata.left.total[d.BS]++
      pdata.left[d.TaggedPitchType].count++
      pdata.left[d.TaggedPitchType][d.BS]++
    }
    pdata.general.total.count++
    pdata.general[d.TaggedPitchType].count++
    if ((d.Strikes + d.Balls) < 2) {
      pdata.general.total.ft++
      pdata.general[d.TaggedPitchType].ft++
      if ((d.Strikes + d.Balls) === 0) {
        pdata.general.total.fp++
        pdata.general[d.TaggedPitchType].fp++
      }
    }
    if (d.Strikes === 2) {
      pdata.general.total.ts++
      pdata.general[d.TaggedPitchType].ts++
    }
    if (d.Strikes > d.Balls) {
      pdata.general.total.pa++
      pdata.general[d.TaggedPitchType].pa++
    }
    if (d.Strikes < d.Balls) {
      pdata.general.total.pb++
      pdata.general[d.TaggedPitchType].pb++
    }
    if (d['On-Base'] >= 1) {
      pdata.general.total.risp++
      pdata.general[d.TaggedPitchType].risp++
    }
    if (d.PA_Result !== "" && (!non_ab_set.includes(d.PA_Result))) {
      pdata.general[d.TaggedPitchType].ab++
      if (hit_set.includes(d.PA_Result)) pdata.general[d.TaggedPitchType].h++
    }
    if (d.Zone) {
      pdata.general[d.TaggedPitchType].zone++
    } else {
      pdata.general[d.TaggedPitchType].ocount++
      if (swing_set.includes(d.PitchCode)) pdata.general[d.TaggedPitchType].oswing++
    }
  }
  for (const tag in pdata.general) {
    if (tag === 'total') continue
    let row = []
    row.push(getPercentageData(pdata.general[tag].count, pdata.general.total.count, 0))
    row.push(getPercentageData(pdata.general[tag].fp, pdata.general.total.fp, 0))
    row.push(getPercentageData(pdata.general[tag].ft, pdata.general.total.ft, 0))
    row.push(getPercentageData(pdata.general[tag].ts, pdata.general.total.ts, 0))
    row.push(getPercentageData(pdata.general[tag].pa, pdata.general.total.pa, 0))
    row.push(getPercentageData(pdata.general[tag].pb, pdata.general.total.pb, 0))
    row.push(getPercentageData(pdata.general[tag].risp, pdata.general.total.risp, 0))
    row.push(getPercentageData(pdata.general[tag].zone, pdata.general[tag].count, 0))
    row.push(getPercentageData(pdata.general[tag].oswing, pdata.general[tag].ocount, 0))
    row.push(getDecimalData(pdata.general[tag].h, pdata.general[tag].ab, 3))
    tables.general.push({title: <>{TaggedPitchTypeLabelMap[tag]} <span>{tag}</span></>, data: row})
  }
  for (const tag in pdata.left) {
    if (tag === 'total') continue
    let row = []
    for (const col of ['count', '0-0', '0-1', '0-2', '1-0', '1-1', '1-2', '2-0', '2-1', '2-2', '3-0', '3-1', '3-2']) {
      row.push(getPercentageData(pdata.left[tag][col], pdata.left.total[col], 0))
    }
    tables.left.push({title: <>{TaggedPitchTypeLabelMap[tag]} <span>{tag}</span></>, data: row})
  }
  for (const tag in pdata.right) {
    if (tag === 'total') continue
    let row = []
    for (const col of ['count', '0-0', '0-1', '0-2', '1-0', '1-1', '1-2', '2-0', '2-1', '2-2', '3-0', '3-1', '3-2']) {
      row.push(getPercentageData(pdata.right[tag][col], pdata.right.total[col], 0))
    }
    tables.right.push({title: <>{TaggedPitchTypeLabelMap[tag]} <span>{tag}</span></>, data: row})
  }

  return tables
}

export const extractBatterOverallData = (data) => {
  const output = {
    discipline: [],
    hit: [],
  }
  const grepData = {
    discipline: {count: 0, strk: 0, zswing: 0, oswing: 0, zcount: 0, ocount: 0, contact: 0, zcontact: 0, ocontact: 0, miss: 0, whiff: 0, swing: 0, inplay: 0, call: 0, firstp_s: 0, first_p: 0},
    hit: {gb: 0, ld: 0, fb: 0, ifb: 0, hard: 0, soft: 0, med: 0, oppo: 0, straight: 0, pull: 0, hr: 0, bunt: 0, bunt_h: 0, inf_h: 0},
  }
  let groupByPitchType = { all: {...grepData} }
  groupByPitchType.all.gameSet = new Set()
  for (const d of data) {
    groupByPitchType.all.discipline.count++
    if (d.PitchCode === 'In-Play') {
      groupByPitchType.all.discipline.inplay++
      //Hit
      groupByPitchType.all.hit[hittype_map[d.HitType]]++
      groupByPitchType.all.hit[d.HardnessTag.toLowerCase()]++
      let dirTag = getHitDirectionTag(d.BatS, d.Theta)
      groupByPitchType.all.hit[dirTag]++
      if (d.PA_Result === 'HR') groupByPitchType.all.hit.hr++
      if (['SBUNT','BUNT'].includes(d.BuntTag)) groupByPitchType.all.hit.bunt++
      if (['SBUNT','BUNT'].includes(d.BuntTag) && hit_set.includes(d.PA_Result)) groupByPitchType.all.hit.bunt_h++
      if (d.HitTag === 'INFH') groupByPitchType.all.hit.inf_h++
    }
    if (d.PitchCode === 'Strk-C') groupByPitchType.all.discipline.call++
    if (parseInt(d.Balls) === 0 && parseInt(d.Strikes) === 0) {
      groupByPitchType.all.discipline.first_p++
      if (strk_set.includes(d.PitchCode)) groupByPitchType.all.discipline.firstp_s++
    }
    if (strk_set.includes(d.PitchCode)) {
      groupByPitchType.all.discipline.strk++
      if (parseInt(d.Zone)) {
        if (d.PitchCode !== 'Strk-C') {
          groupByPitchType.all.discipline.zswing++
          groupByPitchType.all.discipline.swing++
          if (d.PitchCode !== 'Strk-S') {
            groupByPitchType.all.discipline.zcontact++
            groupByPitchType.all.discipline.contact++
          } else {
            groupByPitchType.all.discipline.whiff++
          }
        } else {
          groupByPitchType.all.discipline.miss++
        }
      } else {
        if (d.PitchCode !== 'Strk-C') {
          groupByPitchType.all.discipline.oswing++
          groupByPitchType.all.discipline.swing++
          if (d.PitchCode !== 'Strk-S') {
            groupByPitchType.all.discipline.ocontact++
            groupByPitchType.all.discipline.contact++
          } else {
            groupByPitchType.all.discipline.whiff++
          }
        } else {
          groupByPitchType.all.discipline.miss++
        }
      }
    }
    if (parseInt(d.Zone)) {
      groupByPitchType.all.discipline.zcount++
    } else {
      groupByPitchType.all.discipline.ocount++
    }
    // Score
    groupByPitchType.all.gameSet.add(parseInt(d.GameNo))
  }
  // console.log(groupByPitchType)
  // Calculate for Result
  for (let tag in groupByPitchType) {
    //discipline
    let dcp = []
    // dcp.push(groupByPitchType[tag].discipline.count)
    // dcp.push(getPercentageData(groupByPitchType[tag].discipline.count, groupByPitchType.all.discipline.count))
    // dcp.push(groupByPitchType[tag].discipline.strk)
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.strk, groupByPitchType[tag].discipline.count))
    // dcp.push(groupByPitchType[tag].discipline.zcount)
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.zcount, groupByPitchType[tag].discipline.count))
    // dcp.push(groupByPitchType[tag].discipline.swing)
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.swing, groupByPitchType[tag].discipline.count))
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.zswing, groupByPitchType[tag].discipline.zcount))
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.oswing, groupByPitchType[tag].discipline.ocount))
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.whiff, groupByPitchType[tag].discipline.strk))
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.call, groupByPitchType[tag].discipline.strk))
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.call+groupByPitchType[tag].discipline.whiff, groupByPitchType[tag].discipline.count))
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.firstp_s, groupByPitchType[tag].discipline.first_p))
    // dcp.push(groupByPitchType[tag].discipline.contact)
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.contact, groupByPitchType[tag].discipline.swing))
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.zcontact, groupByPitchType[tag].discipline.zswing))
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.ocontact, groupByPitchType[tag].discipline.oswing))
    // dcp.push(groupByPitchType[tag].discipline.whiff)
    dcp.push(getPercentageData(groupByPitchType[tag].discipline.whiff, groupByPitchType[tag].discipline.swing))
    // dcp.push(getPercentageData(groupByPitchType[tag].discipline.whiff, groupByPitchType[tag].discipline.count))
    // dcp.push(groupByPitchType[tag].discipline.inplay)
    // dcp.push(getPercentageData(groupByPitchType[tag].discipline.inplay, groupByPitchType[tag].discipline.count))
    output.discipline = dcp
    //hit
    let hitd = []
    hitd.push(getDecimalData(groupByPitchType[tag].hit.gb, groupByPitchType[tag].hit.fb, 2, '-'))
    hitd.push(getPercentageData(groupByPitchType[tag].hit.gb, groupByPitchType[tag].discipline.inplay))
    hitd.push(getPercentageData(groupByPitchType[tag].hit.ld, groupByPitchType[tag].discipline.inplay))
    hitd.push(getPercentageData(groupByPitchType[tag].hit.fb, groupByPitchType[tag].discipline.inplay))
    hitd.push(getPercentageData(groupByPitchType[tag].hit.ifb, groupByPitchType[tag].discipline.inplay))
    hitd.push(getPercentageData(groupByPitchType[tag].hit.hr, groupByPitchType[tag].hit.fb))
    hitd.push(getPercentageData(groupByPitchType[tag].hit.inf_h, groupByPitchType[tag].hit.gb))
    hitd.push(getPercentageData(groupByPitchType[tag].hit.bunt_h, groupByPitchType[tag].hit.bunt))
    // TODO: [0811] hardhit -> barrel still unable to determined
    // for (let i=0; i<8; i++) hitd.push('-')
    let pso = groupByPitchType[tag].hit.pull+groupByPitchType[tag].hit.straight+groupByPitchType[tag].hit.oppo
    hitd.push(getPercentageData(groupByPitchType[tag].hit.soft, groupByPitchType[tag].discipline.inplay))
    hitd.push(getPercentageData(groupByPitchType[tag].hit.med, groupByPitchType[tag].discipline.inplay))
    hitd.push(getPercentageData(groupByPitchType[tag].hit.hard, groupByPitchType[tag].discipline.inplay))
    hitd.push(getPercentageData(groupByPitchType[tag].hit.pull, pso))
    hitd.push(getPercentageData(groupByPitchType[tag].hit.straight, pso))
    hitd.push(getPercentageData(groupByPitchType[tag].hit.oppo, pso))
    output.hit = hitd
  }

  return output
}

export const wrapPitcherPersonPageData = (ldata, tdata, prdata, statdata) => {
  let time = new Date()
  let wpalldata = resolvePitcherPersonalData([...ldata, ...tdata])
  const overall_needed = ['G', 'GS', 'SVO', 'W', 'L', 'SV', 'H', 'INN', 'WHIP', 'ERA', 'BC', 'SO', 'GOAO']
  const standard_needed = ['GameType', 'G', 'GS', 'ERA', 'WHIP', 'IP', 'PA', 'H', 'ER', 'HR', 'BB', 'K']
  let wpstatdata = statdata.filter((d)=>(parseInt(d.Year) === time.getFullYear())).map((d) => ({title: d.Year, data: overall_needed.map((e) => (d[e]))}))
  let stdstatdata = statdata.map((d) => ({title: d.Year, data: standard_needed.map((e) => (d[e]))}))
  let total_stddata = getCumulatedStatData(stdstatdata, 'standard', 'p')
  if (total_stddata.length > 0) stdstatdata.push({title: 'Total', data: ['高中生涯', ...total_stddata]})
  // console.log(stdstatdata)
  let integrate_bc_data = extractBallCountData(tdata, 'BatS')
  let zones = extractZoneData(tdata, 'pitcher')
  let situation_pitches = extractZoneDataBySituation(tdata)
  let zone_area_breakdown = extractZoneAreaData(tdata)
  let htmpdata = extractHeapMapData(tdata)
  let gtrenddata = extractPitcherPitchTrendData(tdata)
  let seqdata = { all: extractPitcherSequenceData(tdata), left: extractPitcherSequenceData(tdata, 1), right: extractPitcherSequenceData(tdata, 0)}
  let seqtabledata = extractPitchSequenceTableData(tdata)
  return { ...wpalldata, chart: { ...wpalldata.chart, prGraph: prdata[0]}, ovrstats: calculateOverallStats(statdata, 'pitcher'), ystat: wpstatdata, stdstat: stdstatdata, ibcdata: integrate_bc_data, zones: zones, sitdata: situation_pitches, zabdata: zone_area_breakdown, htmpdata, gtrenddata, seqdata, seqtabledata }
}

export const wrapBatterPersonPageData = (ldata, tdata, prdata, statdata, slogdata) => {
  let time = new Date()
  let wpalldata = resolveBatterPersonalData([...ldata, ...tdata])
  const overall_needed = ['G', 'PA', 'AB', 'RBI', 'R', 'H', 'HR', 'AVG', 'OBP', 'SLG', 'OPS']
  const standard_needed = ['G', 'AB', 'PA', 'H', '1B', '2B', '3B', 'HR', 'R', 'RBI', 'BB', 'IBB', 'K', 'HBP', 'SF', 'SH', 'DP', 'SB', 'CS', 'AVG']
  let stdstatdata = statdata.map((d) => ({title: d.year, data: standard_needed.map((e) => (d[e]))}))
  let wpstatdata = statdata.filter((d)=>(parseInt(d.year) === time.getFullYear())).map((d)=>({title: d.year, data: overall_needed.map((e) => (d[e]))}))
  let total_stddata = getCumulatedStatData(stdstatdata, 'standard', 'b')
  if (total_stddata.length > 0) stdstatdata.push({title: 'Total', data: total_stddata})
  // console.log(stdstatdata)
  let integrate_bc_data = extractBallCountData(tdata, 'PT', true)
  let zones = extractZoneData(tdata, 'batter')
  let situation_pitches = extractZoneDataBySituation(tdata)
  let zone_area_breakdown = extractZoneAreaData(tdata)
  let hit_position_data = extractHitLocationData(tdata)
  let htmpdata = extractHitHeatMap(tdata)
  let scorelogdata = extractBatterScoreLogData(slogdata)
  let overalldata = extractBatterOverallData(tdata)
  //console.log(overalldata)

  return { ...wpalldata, chart: { ...wpalldata.chart, prGraph: prdata[0]}, ovrstats: calculateOverallStats(statdata, 'batter'), ystat: wpstatdata, stdstat: stdstatdata, ibcdata: integrate_bc_data, zones: zones, sitdata: situation_pitches, zabdata: zone_area_breakdown, hlocdata: hit_position_data, htmpdata, scorelogdata, overalldata }
}

export const packForTable = (data) => {
  let packed = []
  for (let i in data) {
    packed.push({title: i, data: data[i]})
  }
  return packed
}

export const packPitchTable = (data) => {
  const headers = ["日期", ...Array.from(data.arsenal).map((e) => `${TaggedPitchTypeLabelMap[e]}${e}`)]
  let pdata = []
  for (const k in data.game) {
    let dt = []
    for (const pt of Array.from(data.arsenal)) {
      if (data.game[k][pt] !== undefined) dt.push(`${Math.round(parseFloat(data.game[k][pt].usage))}% | ${Math.round(parseFloat(data.game[k][pt].avg_velo))} (${data.game[k][pt].high}/${data.game[k][pt].low})`)
      else dt.push('-')
    }
    pdata.push({title: k, data: dt})
  }
  return { headers, data: pdata }
}

export const wrapGameLog = (type, data) => {
  if (data.length === 0) return { headers: [], data: [] }
  const headers = {
    pitcher: ['日期', '場次', '對手', 'W', 'L', 'HLD', 'SV', 'BS', 'IP', 'H', 'HR', 'R', 'ER', 'BB', 'SO'],
    batter: ['日期', '場次', '對手', 'PA', 'AB', 'R', 'H', '2B', '3B', 'HR', 'RBI', 'BB', 'SO', 'SB', 'CS']
  }
  let month = parseInt(data[0].M)
  let table = []
  let cumulated_month = [`${month}月`, 0, 'CPBL', 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  for (const d of data) {
    if (parseInt(d.M) !== month) {
      cumulated_month[8] = cumulated_month[8]%3 === 0? `${cumulated_month[8]/3}`:`${Math.floor(cumulated_month[8]/3)}.${cumulated_month[8]%3}`
      table.push({data: [...cumulated_month]})
      month = parseInt(d.M)
      cumulated_month = [`${month}月`, 0, 'CPBL', 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    }
    let row = []
    let dt = new Date(d.game_date).getTime()
    let time = new Date(dt + 8 * 3600)
    row.push(`${time.getMonth()+1}/${time.getDate()}`)
    row.push(d.game_No)
    cumulated_month[1]++
    row.push(d.oppo_team)
    if (type === 'pitcher') {
      row.push(d.W)
      cumulated_month[3] += parseInt(d.W)
      row.push(d.L)
      cumulated_month[4] += parseInt(d.L)
      row.push(d.H)
      cumulated_month[5] += parseInt(d.H)
      row.push(d.SV)
      cumulated_month[6] += parseInt(d.SV)
      row.push(d.BS)
      cumulated_month[7] += parseInt(d.BS)
      row.push(d.INN)
      cumulated_month[8] += parseInt(d.Outs)
      row.push(d.Hit)
      cumulated_month[9] += parseInt(d.Hit)
      row.push(d.HR)
      cumulated_month[10] += parseInt(d.HR)
      row.push(d.R)
      cumulated_month[11] += parseInt(d.R)
      row.push(d.ER)
      cumulated_month[12] += parseInt(d.ER)
      row.push(d.BB)
      cumulated_month[13] += parseInt(d.BB)
      row.push(d.SO)
      cumulated_month[14] += parseInt(d.SO)
    } else {
      row.push(d.PA)
      cumulated_month[3] += parseInt(d.PA)
      row.push(d.AB)
      cumulated_month[4] += parseInt(d.AB)
      row.push(d.R)
      cumulated_month[5] += parseInt(d.R)
      row.push(d.H)
      cumulated_month[6] += parseInt(d.H)
      row.push(d['2B'])
      cumulated_month[7] += parseInt(d['2B'])
      row.push(d['3B'])
      cumulated_month[8] += parseInt(d['3B'])
      row.push(d.HR)
      cumulated_month[9] += parseInt(d.HR)
      row.push(d.RBI)
      cumulated_month[10] += parseInt(d.RBI)
      row.push(d.BB)
      cumulated_month[11] += parseInt(d.BB)
      row.push(d.K)
      cumulated_month[12] += parseInt(d.K)
      row.push(d.SB)
      cumulated_month[13] += parseInt(d.SB)
      row.push(d.CS)
      cumulated_month[14] += parseInt(d.CS)
    }

    table.push({data: row})
  }
  cumulated_month[8] = cumulated_month[8]%3 === 0? `${cumulated_month[8]/3}`:`${Math.floor(cumulated_month[8]/3)}.${cumulated_month[8]%3}`
  table.push({data: [...cumulated_month]})

  return { headers: headers[type], data: table }
}

export const wrapMultipleRowStatsData = (columns, data) => {
  const column_key = {}
  // let table_advance = 
}